import axios from "axios";
import {
  getHeaders,
  checkStatus,
} from "../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";

const baseURL = process.env.REACT_APP_BASE_URL;

export async function getAttendance(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getAttendanceHistory(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/History`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getIisActivateLocation(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/ActivateDeactivate`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getCurrentCheckInStatus(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/CurrentCheckInStatus`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function selfRemarkAttendance(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/Update`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getRegularAttandance(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/Regularization/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// export async function updateRegularAttendance(params) {
//     try {
//       const response = await axiosInstance.post(`${baseURL}/Attendance/Regularisation/Status`, params, {
//         headers: await getHeaders(),
//         body: JSON.stringify(params)
//       });
//       checkStatus(response);
//       return response.data;
//     }catch(error){
//       return Promise.reject(error);
//     }
//   }

export async function updateRegularization(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/Regularization/Update`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addRegularAttandance(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/Regularization/Add`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addGeoTagLocation(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/AddUpdate`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getGeoTagLocation(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/List`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function deleteGeoTagLocation(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/Delete`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getGeoTagRegion(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/GeoTagRegion?RegionId=${params.RegionId}`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function addGeoTagLocationAssign(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/Assign`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function removeGeoTagLocationAssign(params) {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Attendance/GeoTagLocation/UnAssign`,
      params,
      {
        headers: await getHeaders(),
        body: JSON.stringify(params),
      },
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
